<template>
  <v-container>
    <v-layout wrap justify-space-between>
      <v-flex xs12 md5 class="order-md2 mx-3 mb-5">
        <v-card class="round elevation-4">
          <v-card-title>
            <h2 class="headline font-weight-bold px-3">Create a New Account</h2>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pt-0">
            <sign-on></sign-on>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex class="headline pa-3 order-md1" xs12 md6>
        <div class="statements">
          <div><img :src="require('../assets/dice.png')" width="90px"></div>
          <div>
            <p><span class="font-weight-bold">Instaplay with friends</span><br>and the world around you.</p>
          </div>

          <div><img :src="require('../assets/globe.png')" width="90px"></div>
          <div>
            <p><span class="font-weight-bold">Create Instaplays</span><br>and invite friends and the world to
              participate.
            </p>
          </div>

          <div><img :src="require('../assets/prize.png')" width="100px"></div>
          <div>
            <p><span class="font-weight-bold">Win prizes</span> and award prizes.</p>
            <p><span class="font-weight-bold">It is free.</span></p>
          </div>
        </div>
      </v-flex>
    </v-layout>
    <social-links />
  </v-container>
</template>

<script>
    import SignOn from "@/pages/SignOn";
    import SocialLinks from "@/components/SocialLinks";

    export default {
        name: "LogInOrSignOn",
        components: {SocialLinks, SignOn}
    }
</script>

<style scoped>
  .round {
    border-radius: 0.75rem;
  }

  .statements {
    grid-template-columns: 120px auto;
    display: grid;
    grid-row-gap: 4rem;
    align-items: center;
  }

  .twitter {
    position: relative;
    display: inline-block;
    width: 21px;
    height: 21px;
    top: 1px;
    background-image: url(data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2072%2072%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h72v72H0z%22%2F%3E%3Cpath%20class%3D%22icon%22%20fill%3D%22%23fff%22%20d%3D%22M68.812%2015.14c-2.348%201.04-4.87%201.744-7.52%202.06%202.704-1.62%204.78-4.186%205.757-7.243-2.53%201.5-5.33%202.592-8.314%203.176C56.35%2010.59%2052.948%209%2049.182%209c-7.23%200-13.092%205.86-13.092%2013.093%200%201.026.118%202.02.338%202.98C25.543%2024.527%2015.9%2019.318%209.44%2011.396c-1.125%201.936-1.77%204.184-1.77%206.58%200%204.543%202.312%208.552%205.824%2010.9-2.146-.07-4.165-.658-5.93-1.64-.002.056-.002.11-.002.163%200%206.345%204.513%2011.638%2010.504%2012.84-1.1.298-2.256.457-3.45.457-.845%200-1.666-.078-2.464-.23%201.667%205.2%206.5%208.985%2012.23%209.09-4.482%203.51-10.13%205.605-16.26%205.605-1.055%200-2.096-.06-3.122-.184%205.794%203.717%2012.676%205.882%2020.067%205.882%2024.083%200%2037.25-19.95%2037.25-37.25%200-.565-.013-1.133-.038-1.693%202.558-1.847%204.778-4.15%206.532-6.774z%22%2F%3E%3C%2Fsvg%3E);
  }

  .facebook {
    background-image: url(data:image/svg+xml;base64,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);
  }
</style>
